export class EnviromentVars {
  /*
  Ver com Daniel
  Ajustar para funcionar por diretórios e não por portas
 */
  /* Cookie Session */
  static cookieName = 'SaibDirect';
  static cookieDomain = 'saibweb.com.br';

  /* ID Actual Module/Menu
   0 - Menu Direct
   1 - Operacional
   2 - Marketing
   3 - Painel de Monitoramento
   4 - Análise de resultados
  */
  static idAtualModule = 0;

  /* Back-end */
  static urlDirectBack = 'https://dportal.saibweb.com.br';
  static urlDirectBackMarketing = 'https://mktback.saibweb.com.br';
  static urlDirectBackVoucher = 'https://voucherback.saibweb.com.br';
  static urlDirectBackOfertas = 'https://ofertasback.saibweb.com.br';
  static urlDirectBackBookBasico = 'https://bookbasicoback.saibweb.com.br';
  static urlDirectBackOperacional = 'https://operacionalback.saibweb.com.br';

  /* Front-end */
  static urlDirectFront = 'https://direct.saibweb.com.br';
  static urlDirectFrontMarketing = 'https://mkt.saibweb.com.br';
  static urlDirectFrontVoucher = 'https://voucher.saibweb.com.br';
  static urlDirectFrontOfertas = 'https://ofertas.saibweb.com.br';
  static urlDirectFrontBookBasico = 'https://bookbasico.saibweb.com.br';
  static urlDirectFrontOperacional = 'https://operacional.saibweb.com.br';
}
